class ALGProductColours extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-alg-colour-link]');
      if (!link) return;
      event.stopPropagation();
      if (!this.hasAttribute('data-preserve-size')) return;
      const root = this.closest('.product-details') || this.closest('.shopify-section');
      const picker = root?.querySelector('variant-picker');
      const selected = picker?.querySelector('input[type="radio"]:checked, select');
      const size = selected?.value?.trim().toUpperCase();
      if (!size) return;
      const variants = JSON.parse(link.dataset.variants || '[]');
      const variant = variants.find((item) => item.size === size);
      if (!variant) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', variant.id);
      link.href = url.href;
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() {
    this.abort?.abort();
  }
}
if (!customElements.get('alg-product-colours')) customElements.define('alg-product-colours', ALGProductColours);
